// extracted by mini-css-extract-plugin
export default {"iosSafeAreaOffset":"IosSafeAreaBottom_iosSafeAreaOffset__lrNYF","iosSafeAreaPlaceholder":"IosSafeAreaBottom_iosSafeAreaPlaceholder__bZLMh"};